module.exports = __webpack_public_path__ + "img/edoge.1501e8dd.svg";